import React, { useState, useMemo } from "react";
import { useMasterData } from "../context/MasterDataContext";
import { useNavigate, useLocation } from "react-router-dom";
import Select from "react-select";
import "../Styles/LoginPage.css";
import logo from "../assests/images/LoginLogo.png";
import { saveData } from "../utils/store-data";
import {
  AGENT_LOGIN,
  CLIENT_LOGIN,
  CLIENT_PROFILE_CODE,
  GOOGLE_USER,
  IS_TEMP_REGISTERED,
  LOGIN_BY,
  PHNO,
  PROFILE_LOGIN,
  USER_EMAIL,
  USER_ID,
} from "../utils/store-data-constants";
import {
  get_all_countries,
  log_in_by_google,
  register_user_by_email,
} from "../api/serverWrapper";
import { GOOGLE_LOGIN_API } from "../api/app_url";
import { useGoogleLogin } from "@react-oauth/google";
import UserSystemRole from "../components/UserSystemRole";
import EmailLogin from "./EmailLogin";
import EmailSignup from "./EmailSignup";
import VerifyEmailOtp from "./VerifyEmailOtp";
import {
  loginByEmail,
  loginByGoogle,
  loginByPhoneNo,
} from "../utils/Constants";
import { isValidPhoneNumber } from "libphonenumber-js";
import { getPhoneCountryOptions } from "../utils/commonFunctions";

const SignUp = () => {
  const location = useLocation();
  const loginType = location.state?.loginType || "Agent";
  const [emailMode, setEmailMode] = useState(null);
  const [signupEmail, setSignupEmail] = useState("");
  const [signupPassWord, setSignupPassWord] = useState("");
  // null | "login" | "signup"
  const [loading, setLoading] = useState(false);
  const [loadingforMobile, setLoadingforMobile] = useState(false);
  const [loadingforFacebook, setLoadingforFaceBook] = useState(false);

  const [phone, setPhone] = useState("");

  const [showSelect, setShowSelect] = useState(false);

  const navigate = useNavigate();

  const {
    allCountyMasterData,
    selectedCountryCode,
    setSelectedCountryCode,
    selectedCountryIsoCode,
    setSelectedCountryIsoCode,
  } = useMasterData();

  const countries = useMemo(
    () => getPhoneCountryOptions(allCountyMasterData),
    [allCountyMasterData],
  );

  const selectedCountryOption =
    countries.find((country) => country.isoCode === selectedCountryIsoCode) ||
    countries.find((country) => country.value === String(selectedCountryCode)) ||
    null;

  const googleLogin = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      setLoading(true);
      try {
        const res = await fetch(
          GOOGLE_LOGIN_API,
          {
            headers: {
              Authorization: `Bearer ${tokenResponse.access_token}`,
            },
          },
        );

        console.log(res);

        if (!res.ok) {
          throw new Error("Failed to fetch Google user info");
        }

        const data = await res.json();

        console.log("Google user:", data);

        /*
        data contains:
        - email
        - name
        - picture
        - sub (google user id)
      */

        // 👉 Send this to your backend
        // await api.googleLogin(data);

        // navigate("/otp_verify", { state: { loginType } });
        await login(data.email, data);
      } catch (err) {
        console.error("Google login error", err);
        alert("Google Login Failed");
      } finally {
        setLoading(false);
      }
    },
    onError: () => {
      alert("Google Login Failed");
    },
  });

  const login = async (EMail, UserInfo) => {
    let data = {
      EMail: EMail,
    };

    try {
      let resp = await log_in_by_google(data);
      console.log(resp);

      if (resp.data) {
        let user = resp.data;
        await saveData(USER_ID, resp.data.UserId);
        if (resp.data.SystemRole === UserSystemRole.AGENT.id) {
          await saveData(AGENT_LOGIN, true);
          await saveData(PROFILE_LOGIN, false);
          await saveData(CLIENT_LOGIN, false);
          navigate("/dashboard", { replace: true });
        } else if (resp.data.SystemRole === UserSystemRole.CLIENT.id) {
          if (user?.client?.ParentId) {
            await saveData(AGENT_LOGIN, false);
            await saveData(PROFILE_LOGIN, false);
            await saveData(CLIENT_LOGIN, true);
            navigate("/dashboard", { replace: true });
          } else {
            await saveData(AGENT_LOGIN, false);
            await saveData(CLIENT_LOGIN, false);
            await saveData(PROFILE_LOGIN, true);
            await saveData(CLIENT_PROFILE_CODE, user.profile.ClientCode);
            navigate("/profileforclient", {
              replace: true,
              state: { client: user.profile },
            });
          }
        } else {
          alert("Invalid Email");
          navigate("/home");
        }
      } else {
        await saveData(LOGIN_BY, loginByGoogle);
        await saveData(USER_EMAIL, EMail);
        await saveData(GOOGLE_USER, JSON.stringify(UserInfo));
        navigate("/terms-and-conditions");
      }
    } catch (error) {
      console.log(error);
    }
  };

  // Handle login
  const handleLogin = async () => {
    // if (!/^\d{10}$/.test(phone)) {
    //   alert("Enter a valid 10-digit number");
    //   return;
    // }

    const fullPhoneNumber = `+${selectedCountryCode}${phone}`;

    if (!isValidPhoneNumber(fullPhoneNumber, selectedCountryIsoCode)) {
      alert("Enter a valid mobile number");
      return;
    }

    setLoadingforMobile(true);
    try {
      await saveData(PHNO, `${phone}`);
      await saveData(LOGIN_BY, loginByPhoneNo);
      navigate("/otp_verify", { state: { loginType } });
    } finally {
      setLoadingforMobile(false);
    }
  };

  const selectStyles = {
    option: (provided) => ({
      ...provided,
      textAlign: "left",
      paddingLeft: "12px",
    }),
    singleValue: (provided) => ({
      ...provided,
      textAlign: "left",
    }),
    menu: (provided) => ({
      ...provided,
      textAlign: "left",
    }),
  };

  const navigateToRegisterScreen = async () => {
    try {
      let data = {
        EMail: signupEmail,
        Password: signupPassWord,
        SystemRole:
          loginType === "Agent"
            ? UserSystemRole.AGENT.id
            : UserSystemRole.CLIENT.id,
        IsTempRegistered: 1,
        LoginBy: loginByEmail,
      };

      let res = await register_user_by_email(data);
      if (res.success) {
        await saveData(LOGIN_BY, loginByEmail);
        await saveData(USER_EMAIL, signupEmail);
        await saveData(USER_ID, res.data.UserId);
        await saveData(IS_TEMP_REGISTERED, true);
        if (loginType === "Agent") {
          navigate("/business_setup");
        } else {
          navigate("/client_setup");
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="login-wrapper">
      <div className="left-panel">
        <div className="curve-image"></div>
        <img src={logo} alt="WedLuk Logo" className="logo" />
        <p className="tagline-for-login">
          Matrimony reimagined for the AI generation.
        </p>
      </div>

      <div className="right-panel">
        {emailMode === null && (
          <div className="login-card">
            <h2> Signup</h2>

            {/* Phone Input with Country Code Selector */}
            <form
              onSubmit={(e) => {
                e.preventDefault();
                handleLogin();
              }}
            >
              <div className="phone-input">
                <span
                  className="country-code"
                  onClick={() => setShowSelect((prev) => !prev)}
                  style={{ cursor: "pointer" }}
                >
                  +{selectedCountryCode}
                </span>

                <input
                  type="tel"
                  placeholder="Contact Number"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value.replace(/\D/g, ""))}
                  maxLength={15}
                />
              </div>
              {showSelect && (
                <div className="country-select-popup">
                  <Select
                    classNamePrefix="react-select"
                    options={countries}
                    styles={{
                      ...selectStyles,
                      menuPortal: (provided) => ({
                        ...provided,
                        zIndex: 10000,
                      }),
                    }}
                    value={selectedCountryOption}
                    getOptionValue={(option) => option.isoCode}
                    onChange={(opt) => {
                      if (opt) {
                        setSelectedCountryCode(opt.value);
                        setSelectedCountryIsoCode(opt.isoCode);
                        setShowSelect(false);
                      }
                    }}
                    autoFocus
                    isSearchable
                    menuPlacement="auto"
                    menuPosition="fixed"
                    menuPortalTarget={document.body}
                    maxMenuHeight={240}
                  />
                </div>
              )}


              <button
                type="submit"
                className="login-btn-login"
                disabled={loadingforMobile}
              >
                {loadingforMobile ? (
                  <span className="spinner"></span>
                ) : (
                  <>
                    Signup <span className="login-arr">{">"}</span>
                  </>
                )}
              </button>
            </form>

            <div className="divider-or-use">or use</div>

            <button
              className="login-google"
              onClick={googleLogin}
              disabled={loading}
            >
              {loading ? (
                <span className="spinner"></span>
              ) : (
                <>
                  <i className="fab fa-google"></i> Signup using Google →
                </>
              )}
            </button>

            {/* <button
            className="login-email"
            
            disabled={loadingforFacebook}
          >
            {loadingforFacebook ? (
              <span className="spinner"></span>
            ) : (
              <>
                <i className="fab fa-facebook-f"></i> Login using Facebook →
              </>
            )}
          </button> */}

            <button
              className="login-email"
              onClick={() => setEmailMode("signup")}
            >
              <i className="fa-solid fa-envelope-circle-check"></i> {"  "}
              Signup using Email →
            </button>
          </div>
        )}

        {emailMode === "login" && (
          <EmailLogin setEmailMode={setEmailMode} loginType={loginType} />
        )}

        {emailMode === "signup" && (
          <EmailSignup
            setEmailMode={setEmailMode}
            setSignupEmail={setSignupEmail}
            setSignupPassWord={setSignupPassWord}
          />
        )}

        {emailMode === "otp" && (
          <VerifyEmailOtp
            email={signupEmail}
            // onVerified={() => navigateToRegisterScreen()}
            onVerified={() => {
              navigate("/login", {
                state: {
                  signupEmail,
                  signupPassWord,
                  isEmailSignup: true,
                },
              });
            }}
          />
        )}

        {/* <div className="signup-box">
          <p
            onClick={googleLogin}
            disabled={loading}
            style={{ cursor: "pointer" }}
          >
            Not registered with us? Signup →
          </p>
          <p className="subtext">
            Sign up to grow your client base, manage effortlessly & serve
            families with confidence.
          </p>
        </div> */}
      </div>
    </div>
  );
};

export default SignUp;
